module.exports = __webpack_public_path__ + "img/4-1-283x400.5ed79118.jpg";